import variables from './variables';

require('./bootstrap.css');
require('./fonts.css');
require('./utils.css');
require('./base.css');
require('./animations.css');
require('./css-transition-group.css');

/* Third-party */
require('normalize.css');

// eslint-disable-next-line import/prefer-default-export
export { variables };



// WEBPACK FOOTER //
// ../statics/stylesheets/index.js